  function ShopifyMappingCtrl($state, $stateParams, $rootScope, toaster, ShopifyMappingService, CommonService,$timeout) {
  'ngInject'

  const vm = this;
  vm.orgId = $rootScope.orgId;
  vm.editMapping = {};
  vm.mapping = {};
  vm.shopifyForm = {};
  vm.loading=false;
  vm.regex = '^[-+]?[0-9]*\.?[0-9]+$';
  vm.contactLoader = false;
  vm.editMapping = $stateParams.editMapping;
  if (vm.editMapping) {
    vm.editFlag = true;
  }
  vm.shopifyForm = vm.editMapping || {};
  if (angular.equals({}, vm.shopifyForm)) {
    vm.shopifyForm = {
      api_v1_shopify_mapping_acs_attributes: [
      {account_name: "shopify_sales"},
      {account_name: "sales_tax_liability"},
      {account_name: "shipping_income"},
      {account_name: "merchant_account_fees"},
      {account_name: "refund_after_sales"}
      ]
    }
  }

  vm.init = function () {
    vm.loading = true;
    ShopifyMappingService.getMapping($stateParams.orgId, function (response) {
      vm.loading = false;
      if(response.status == 200) {
        vm.mapping = response.data;
      }
    });
  };

  vm.getAccounts = function(){
   CommonService.getAccounts($stateParams.orgId, function (response) {
    vm.accounts = response.data;
  });

   ShopifyMappingService.getContacts($stateParams.orgId, function (response) {
    vm.contacts = response.data;
  });
 }

 vm.createMapping = function (shopifyForm) {
     vm.responseReceived = false;
     ShopifyMappingService.createMapping(ShopifyMappingService.getShofyMapping(vm.shopifyForm), $stateParams.orgId, function (response) {
       vm.responseReceived = true;
       vm.shopifyForm = {};
       shopifyForm.$setPristine();
       shopifyForm.$setUntouched();
       if (response.status >= 200 & response.status < 300) {
         toaster.pop('info', (vm.editFlag ? 'Shopify mapping updated.' : 'Shopify mapping created.'));
         $state.go('user.organization.settingView.mapping.shopify-mapping', {orgId: $stateParams.orgId}, {inherit: false});
       }
       else {
         toaster.pop('error', Object.values(response.data)[0].join(','));
         $state.go('user.organization.settingView.mapping.shopify-mapping', {orgId: $stateParams.orgId}, {inherit: false});
       }
     });
 }

 vm.checkUniqueAccountValidation = function(shopifyForm){
   let valueArr = vm.shopifyForm.api_v1_shopify_mapping_acs_attributes.map(function(item){ return item.api_v1_account });
   let isDuplicate = valueArr.some(function(item, idx){
     return valueArr.indexOf(item) != idx
   });
   if(isDuplicate) {
     shopifyForm.account0.$setValidity("uniqueAccount", false);
   } else {
     shopifyForm.account0.$setValidity("uniqueAccount", true);
   }
   return !isDuplicate;
 };


 vm.deleteMapping = function () {
  swal({
    title: "Are you sure?",
    text: "Do you want to delete this mapping?",
    icon: "warning",
    dangerMode: true,
    buttons: [true, true]
  })
  .then(willDelete => {
    if (willDelete) {
      ShopifyMappingService.deleteMapping($stateParams.orgId, function (response) {
        if (response.status == 204) {
          vm.mapping = ' ';
          toaster.pop('info', 'Mapping deleted.');
        } else {
          toaster.pop('error', 'Mapping cannot be deleted.');
        }
        $state.go('user.organization.settingView.mapping.shopify-mapping', {orgId: $stateParams.orgId}, {inherit: false});
      });
    }
  });
};

vm.editMapping = function (mapping) {
  $state.go('user.organization.settingView.mapping.shopifyNewMapping', {
    orgId: $stateParams.orgId,
    editMapping: mapping
  }, {inherit: false});
};
vm.updateTest = function(d,$event){
  if($event && $event.type == 'paste'){
  $timeout(function() {
    vm.addContact = angular.element($event.target).val();
  });
} else {
   vm.addContact =  (d.search && d.search != "")? d.search :  d.selected.name;
}
};
vm.addNewContact = function(){
    vm.contactLoader = true;
    ShopifyMappingService.addNewContact(vm.addContact, $stateParams.orgId, function (response) {
      vm.contactLoader = false;
          if(response.status >= 200 && response.status < 300){
          vm.contacts = [response.data.contact].concat(vm.contacts);
          toaster.pop('info', 'New contact added');
     } else {
      toaster.pop('error', CommonService.throwError(response));
    }
  })
  };
}

export default{
  name: 'ShopifyMappingCtrl',
  fn: ShopifyMappingCtrl
}
